export const PLAN_COLORS = {
  // Blue
  1: { light: '#2196f3', dark: '#1e88e5', text: '#1565c0' },
  // Purple
  2: { light: '#9c27b0', dark: '#8e24aa', text: '#6a1b9a' },
  // Green
  3: { light: '#4caf50', dark: '#43a047', text: '#2e7d32' },
  // Orange
  4: { light: '#ff9800', dark: '#fb8c00', text: '#e65100' },
  // Red
  5: { light: '#f44336', dark: '#e53935', text: '#c62828' },
  // Deep Purple
  6: { light: '#673ab7', dark: '#5e35b1', text: '#4527a0' },
  // Indigo
  7: { light: '#3f51b5', dark: '#3949ab', text: '#283593' },
  // Cyan
  8: { light: '#00bcd4', dark: '#00acc1', text: '#00838f' },
  // Light Green
  9: { light: '#8bc34a', dark: '#7cb342', text: '#558b2f' },
  // Yellow
  10: { light: '#ffc107', dark: '#ffb300', text: '#ff8f00' },
  // Deep Orange
  11: { light: '#ff5722', dark: '#f4511e', text: '#d84315' },
  // Brown
  12: { light: '#795548', dark: '#6d4c41', text: '#4e342e' },
  // Grey
  13: { light: '#757575', dark: '#616161', text: '#424242' },
  // Blue Grey
  14: { light: '#607d8b', dark: '#546e7a', text: '#37474f' },
  // Dark Grey
  15: { light: '#424242', dark: '#37474f', text: '#263238' },
  // NEW COLORS (16-30)
  // Teal
  16: { light: '#009688', dark: '#00796b', text: '#004d40' },
  // Lime
  17: { light: '#cddc39', dark: '#c0ca33', text: '#827717' },
  // Amber
  18: { light: '#ffc107', dark: '#ffb300', text: '#ff6f00' },
  // Pink
  19: { light: '#e91e63', dark: '#c2185b', text: '#880e4f' },
  // Light Blue
  20: { light: '#03a9f4', dark: '#0288d1', text: '#01579b' },
  // Red Orange
  21: { light: '#ff6347', dark: '#ff4500', text: '#dc143c' },
  // Forest Green
  22: { light: '#228b22', dark: '#006400', text: '#013220' },
  // Gold
  23: { light: '#ffd700', dark: '#ffb300', text: '#ff8f00' },
  // Violet
  24: { light: '#8a2be2', dark: '#7b68ee', text: '#4b0082' },
  // Coral
  25: { light: '#ff7f50', dark: '#ff6347', text: '#cd5c5c' },
  // Dark Turquoise
  26: { light: '#00ced1', dark: '#008b8b', text: '#006666' },
  // Olive
  27: { light: '#808000', dark: '#556b2f', text: '#333d1a' },
  // Maroon
  28: { light: '#800000', dark: '#8b0000', text: '#660000' },
  // Navy
  29: { light: '#000080', dark: '#191970', text: '#0a0a3d' },
  // Slate Blue
  30: { light: '#6a5acd', dark: '#483d8b', text: '#2f2f5f' }
} as const;

export type PlanColorIndex = keyof typeof PLAN_COLORS;

/**
 * Get plan color by index, ensuring consistent color assignments
 * If index is out of range, it will cycle through the available colors
 */
export function getPlanColor(index: number) {
  // Ensure the index is between 1 and 30 by using modulo
  // and adding 1 since our indices are 1-based
  const safeIndex = ((index - 1) % Object.keys(PLAN_COLORS).length) + 1 as PlanColorIndex;
  return PLAN_COLORS[safeIndex];
}

export const getColorStyle = (colorIndex: PlanColorIndex, isDark: boolean) => {
  const color = PLAN_COLORS[colorIndex];
  return {
    backgroundColor: isDark ? color.dark : color.light,
    // Use white text for both light and dark backgrounds since we're using more saturated colors
    color: '#ffffff'
  };
}; 